import { create } from 'zustand';

interface SidebarState {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
}

// Initial sidebar visibility: open on desktop, closed on mobile (drawer
// pattern). Viewport-aware initializer avoids the flash where sidebar
// would mount open then immediately close on mobile.
const desktopDefault = typeof window !== 'undefined' && window.innerWidth >= 768;

export const useSidebarStore = create<SidebarState>((set) => ({
  sidebarOpen: desktopDefault,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
}));
